import BaseRoute from 'seshy/routes/base';

export default class AuthenticatedTeamsShowProjectsShowProjectVersionsShowBouncesRoute extends BaseRoute {
  /*
  model(){
    console.log('calling model in AuthenticatedTeamsShowProjectsShowProjectVersionsShowBouncesRoute')
  }
  */
}
